import { gql } from "graphql-request";

export const READ_RELATIONSHIP_DASHBOARD = gql`
  query ReadRelationshipDashboard {
    readRelationshipDashboard {
      totalActiveContacts
      dueFollowUps
      atRiskContacts
      averageRelationshipScore
      clientsCount

      statusBreakdown {
        status
        count
      }

      scoreDistribution {
        rangeLabel
        min
        max
        count
      }

      recentInteractionActivity {
        date
        total
        meaningful
      }

      actionRequiredContacts {
        id
        firstName
        lastName
        companyName
        status
        relationshipScore
        nextFollowUpAt
        lastMeaningfulTouchAt
        atRisk
      }
    }
  }
`;

export const READ_OPERATIONAL_CLARITY_DASHBOARD = gql`
  query ReadOperationalClarityDashboard($auditId: ID!) {
    readOperationalClarityDashboard(auditId: $auditId) {
      summary {
        totalActivities
        processesIdentified
        documentedProcesses
        undocumentedProcesses
        unownedProcesses
        singlePersonDependencies
        staffTrainingGaps
        highImpactGaps
        averageHealthScore
        averageRiskScore
        operationalResilienceScore
      }

      areaRows {
        area
        totalActivities
        processesIdentified
        documentedProcesses
        unownedProcesses
        singlePersonDependencies
        highImpactGaps
        averageHealthScore
        averageRiskScore
      }

      highestRiskActivities {
        id
        auditResponseId
        auditQuestionId
        area
        statement
        description
        businessImpact
        healthScore
        riskScore
        reasons
      }

      recommendedActions {
        id
        auditResponseId
        auditQuestionId
        area
        statement
        actionType
        priority
        reason
        riskScore
      }
    }
  }
`;

export const READ_OPERATIONAL_CLARITY_DASHBOARD_BY_TENANT_ID = gql`
  query ReadLatestOperationalClarityDashboard($tenantId: ID!) {
    readLatestOperationalClarityDashboard(tenantId: $tenantId) {
      summary {
        totalActivities
        processesIdentified
        documentedProcesses
        undocumentedProcesses
        unownedProcesses
        singlePersonDependencies
        staffTrainingGaps
        highImpactGaps
        averageHealthScore
        averageRiskScore
        operationalResilienceScore
      }

      areaRows {
        area
        totalActivities
        processesIdentified
        documentedProcesses
        unownedProcesses
        singlePersonDependencies
        highImpactGaps
        averageHealthScore
        averageRiskScore
      }

      highestRiskActivities {
        id
        auditResponseId
        auditQuestionId
        area
        statement
        description
        businessImpact
        healthScore
        riskScore
        reasons
      }

      recommendedActions {
        id
        auditResponseId
        auditQuestionId
        area
        statement
        actionType
        priority
        reason
        riskScore
      }
    }
  }
`;

export const READ_KNOWLEDGE_COVERAGE_DASHBOARD = gql`
  query ReadKnowledgeCoverageDashboard($tenantId: ID!) {
    readKnowledgeCoverageDashboard(tenantId: $tenantId) {
      summary {
        totalAssignments
        notViewed
        readOnly
        understood
        knowledgeCoveragePercent
      }

      departmentRows {
        id
        departmentName
        assignedCount
        notViewedCount
        readOnlyCount
        understoodCount
        coveragePercent
      }

      userRows {
        id
        userName
        assignedCount
        notViewedCount
        readOnlyCount
        understoodCount
        outstandingCount
        status
      }

      sopRows {
        id
        sopTitle
        departmentName
        assignedCount
        notViewedCount
        readOnlyCount
        understoodCount
        coveragePercent
      }

      recentlyUpdatedRows {
        id
        sopTitle
        version
        updatedAt
        assignedCount
        outstandingCount
        status
      }
    }
  }
`;